module.exports = __webpack_public_path__ + "static/media/login.7f714178.svg";